module.exports = __webpack_public_path__ + "static/media/m21.55c9905d.jpg";